import React from 'react';
import './CollegeFundListActionBarLink.scss';

const CollegeFundListActionBarLink: React.VFC = () => {
  return (
    <React.Fragment>
      Add a
      <span className="college-fund-list-action-bar-link-target">
        {' '}
        new portfolio{' '}
      </span>
      to an existing beneficiary, or
      <span className="college-fund-list-action-bar-link-target">
        {' '}
        set up an account{' '}
      </span>
      for a new beneficiary.
    </React.Fragment>
  );
};

export default CollegeFundListActionBarLink;
